import React, { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import CenteredLoader from 'components/view/CenteredLoader'

import Modal from '../Modal'
import { palette } from '../../theme/palette'
import {
  ModalWrapper,
  ModalContainer,
  CloseButtonContainer,
  ModalContent,
  ModalHeader,
  WebViewImage,
  LoaderContainer
} from '../containers/Webview/WebviewModal/WebviewModal.style'
import { CloseWidgetIcon } from '../../icons/Icons'
import { ImageModalSettings, SettingsType } from '../../models/SettingsType'
import { focusTrapCreator } from '../../helper/focusTrapCreator'

interface Props {
  imageUrl: string
  imageAltText: string
  setImageModalSettings: (props: ImageModalSettings) => void
  settings: SettingsType
}

const ImageModal: React.FC<Props> = ({
  imageUrl,
  imageAltText,
  setImageModalSettings,
  settings
}) => {
  const webViewModalRef = useRef(null)
  const closeWebViewButtonRef = useRef(null)
  const { t } = useTranslation()
  const [isLoading, setIsLoading] = useState(true)

  const handleClose = () => {
    setImageModalSettings({
      imageModalSrc: '',
      imageAltText: ''
    })
  }

  useEffect(() => {
    closeWebViewButtonRef.current.focus()
  }, [])

  const imageLoadHandler = () => {
    setIsLoading(false)
  }

  return (
    <Modal
      onClose={handleClose}
    >
      <ModalWrapper
        ref={webViewModalRef}
        aria-label={t('webview_image')}
        role='dialog'
        aria-modal='true'
        onKeyDown={(e) => focusTrapCreator(e, webViewModalRef.current, true)}
      >
        <ModalContainer>
          <ModalHeader data-test='imageModal-header'>
            <CloseButtonContainer
              ref={closeWebViewButtonRef}
              aria-label={t('webview_close')}
              onClick={handleClose}
            >
              <CloseWidgetIcon color={palette.secondaryText} />
            </CloseButtonContainer>
          </ModalHeader>
          <ModalContent
            isDobContent={false}
            isLoading={isLoading}
            data-test='imageModal-content'
          >
            <WebViewImage
              src={imageUrl}
              alt={imageAltText}
              isNeedMargin={false}
              onLoad={imageLoadHandler}
            />
          </ModalContent>

          {isLoading &&
            <LoaderContainer>
              <CenteredLoader position={'relative'} size={48} borderTopColor={settings?.color} />
            </LoaderContainer>
          }
        </ModalContainer>
      </ModalWrapper>
    </Modal>
  )
}

export default ImageModal
